import React from 'react';
import ComponentHelper from '../../supers/ComponentHelper';
import './activity-log.css';
import RoutingService from '../../services/RoutingService';
import HeaderBreadcrumb from '../../components/header-breadcrumb/HeaderBreadcrumb';

const RS = new RoutingService();

class ActivityLog extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = {
			appStuff: 'Log of events for app: ' + RS.getCurrentApplication()
		};
	}

	render() {
		return (
			<div className="activity-log-view animated fadeIn">
				<HeaderBreadcrumb currentPage="Activity Log" />
				<div>{this.data.appStuff}</div>
			</div>
		);
	}
}

export default ActivityLog;



// WEBPACK FOOTER //
// ./src/views/activity-log/ActivityLog.js